import React from "react";
import { Box } from "@mui/material";
import Lottie from "lottie-react";
import loaderAnimation from "../assets/lottie/ball.json"; // <-- your lottie JSON

const Loader = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // backgroundColor: "rgba(255, 255, 255, 0.1)", // subtle background
        zIndex: 2000,
      }}
    >
      <Lottie
        animationData={loaderAnimation}
        loop
        style={{ width: 150, height: 150 }}
      />
    </Box>
  );
};

export default Loader;
